<template>
  <div
    v-show="visible"
    style="pointer-events: none;"
  >
    <div class="mask"></div>
    <div class="loading-txt">{{ content }}</div>
  </div>
</template>

<script>
import { DEVICE_TYPE } from "@/constant";

export default {
  name: "DowloadBox",
  data() {
    return {
      visible: false,
      isMobile: DEVICE_TYPE.isMobile,
      type: "",
      content: "The game is loading, and the trial play will begin soon",
    };
  },
  methods: {
    hide() {
      this.visible = false;
    },
  },
};
</script>

<style scoped>
.mask {
  position: fixed;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
  z-index: 4;
  /* background: rgba(0, 0, 0, 0.5); */
}
.loading-txt {
  color: rgba(255, 255, 255, 0.88);
  font-size: 4vmin;
  position: fixed;
  z-index: 5;
  bottom: 15%;
  position: fixed;
  left: 0;
  right: 0;
  text-align: center;
  pointer-events: auto;
}
@keyframes ellipsis {
  33% {
    content: ".";
  }
  66% {
    content: "..";
  }
  100% {
    content: "...";
  }
}

.loading-txt::after {
  content: "";
  animation: ellipsis 2.5s steps(3, start) infinite;
}
</style>